import React, { useEffect, useRef } from "react";
import "./Intro.scss";
import people from "../../assets/people.png";
import logo from "../../assets/pfizer-logo.png";
import oval from "../../assets/halfoval.svg";

function Intro() {
  const introLogo = useRef();
  const title = useRef();
  const subTitle = useRef();

  useEffect(() => {
    introLogo.current.style.animation = "appear 0.7s ease-in 0.5s";
    introLogo.current.style.animationFillMode = "forwards";
    title.current.style.animation = "appear 0.7s ease-in 0.7s";
    title.current.style.animationFillMode = "forwards";
    subTitle.current.style.animation = "appear 0.7s ease-in 1s";
    subTitle.current.style.animationFillMode = "forwards";
  }, []);
  return (
    <section className="intro">
      <img src={oval} className="oval" alt="" />
      <img
        className="intro__logo"
        alt="Pfizer logo"
        src={logo}
        ref={introLogo}
      />
      <img
        className="intro__people"
        src={people}
        alt="Side profile silhouettes of people in different skin-tone colors"
      />
      <h1 className="intro__title" ref={title}>
        Health Equity for Skin of Color Starts With Representation
      </h1>
      <p className="intro__subTitle" ref={subTitle}>
        How skin color factors into eczema diagnosis and treatment.
      </p>
    </section>
  );
}

export default Intro;
